import { Colors, Metrics, Helpers } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { ResultTabProps } from './ResultTab.types';
import { ImageHeader, ImageHeaderImage } from './ResultTabComponents/ImageHeader';
import { SystemDetails } from './ResultTabComponents/SystemDetails';
import { Savings } from './ResultTabComponents/Savings';
import { Cost } from './ResultTabComponents/Cost';
import { SavingsBreakdown } from './ResultTabComponents/SavingsBreakdown';
import { RequestQuoteButton } from './ResultTabComponents/RequestQuoteButton';

const Content = styled.div`
  padding: ${Metrics.Spacing.M_Y_SM}px;
  padding-bottom: 0;

  ${Helpers.media.LG`
    padding: ${Metrics.Spacing.M_X_LG}px

  `};
`;

const HR = styled.hr`
  height: 1px;
  border: none;
  background-color: ${Colors.GREY16};
  margin: ${Metrics.Spacing.M_Y_LG}px 0;
`;

export class ResultTab extends React.Component<ResultTabProps> {
  render() {
    const { onShowDisclaimer } = this.props;
    const { solarSaving: savings, solarSystem: system } = this.props.recommendation;
    const imageSize: ImageHeaderImage = system!.size.toLocaleLowerCase() as ImageHeaderImage;
    return (
      <React.Fragment>
        <ImageHeader {...this.props} image={imageSize} />
        <Content>
          <SystemDetails system={system!} />

          {savings && savings.billSavingsForPeriod ? <Savings savings={savings} /> : <HR />}

          <Cost system={system!} savings={savings!} />

          <HR />

          {savings && savings.billSavingsForPeriod ? (
            <React.Fragment>
              <SavingsBreakdown savings={savings!} onShowDisclaimer={onShowDisclaimer} />
            </React.Fragment>
          ) : null}
        </Content>
        {this.props.values ? <RequestQuoteButton {...this.props.values} /> : null}
      </React.Fragment>
    );
  }
}
